import React, { useState, useEffect, useContext } from "react";
import { Alert, Box, Grid, TextField, Typography, Button, Paper, Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { Radio, RadioGroup, FormControl, FormLabel } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import FormGroup from "@mui/material/FormGroup";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import successIcon from '../assets/payment-success-icon.png';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useMember } from '../context/MemberProfileContext';
import RetreatRulesComp from '../components/RetreatRulesComp'
import parse from 'html-react-parser';


import PaymentComp from '../components/PaymentComp'
import PaypalComp from '../components/PaypalComp';
import PaypalZelle from '../components/PaypalZelle';
import { DataContext } from '../App';


export default function MahaShivaratri() {
    const [eventData, setEventData] = useState({
        "balaviharYear": "",
        "membershipType": {
            "name": ""
        },
        status: "",
        eventType: '',
        "notes": "first event1",
        "children": [
        ],
        "medical": {
            "pcpName": "",
            "pcpMobile": "",
            "medicalInsurance": "",
            "groupNo": "",
            "idNo": "",
            "medicalNotes": "",
            "medicalConsentSignedBy": "",
            "treatmentConsentSignedBy": ""
        },
        transaction: {
            quantities: 1,
            itemPrice: 0,
            totalAmount: "",
            donationAmount: "",
            payerId: "",
            notes: "Multiple Events",
        },
        "events": [
        ],
        feeEnabled: 0,
        parent: {
            firstName: "",
            lastName: "",
            email: "",
            mobileNumber: ""

        }
    });
    const { accessToken, signOut } = useAuth();
    const [parentFields, setParentFields] = useState(eventData.parent);  
    const [otherDonationFlag, setOtherDonationFlag] = useState(false);
    const [selectedAmount, setSelectedAmount] = useState(0);
    const [sponsorship, setSponsorship] = useState(0);
    const [donationEventTypes, setDonationEventTypes] = useState([]);
    
      
    const [eventTxnsHistory, setEventTxnsHistory] = useState();
    const [studentFields, setStudentFields] = useState([]);
    const [eventFields, setEventFields] = useState([]);
    //const [culturalEventTypes, setCulturalEventTypes] = useState([]);
    const [eventDescription, setEventDescription] = useState("");
    const [ticketPrice, setTicketPrice] = useState(0);
    const [eventTypeId, setEventTypeId] = useState(0);

    const [sessions, setSessions] = useState();
    const [error, setError] = useState(null);
    const [rulesAccepted, setRulesAccepted] = useState(false); // State to manage checkbox
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const { memberships, setMemberships} = useMember();
    const [parivarMember, setParivarMember] = useState(false);
    const [feeEnabled, setFeeEnabled] = useState(0);
    const [parivarEnabled, setParivarEnabled] = useState(0);

    const { memberProfile, setMemberProfile } = useMember();
    const { eventTypes, setEventTypes } = useMember ();
    const [inputFields, setInputFields] = useState(eventData.transaction);
    const [medicalFields, setMedicalFields] = useState(eventData.medical); 
    const [fullNames, setFullNames] = useState(memberProfile.children.map((child) => child.fullName));
    const [donation, setDonation] = useState(0);
    const [totalAmount, setTotalAmount] = useState(inputFields.quantities * inputFields.itemPrice);
    const [noOfPeople, setNoOfPeople] = useState(0);
    const [donationEventType, setDonationEventType] = useState(0);    
    const [memBvRegdReqd, setMemBvRegdReqd] = useState(); // Membership/Balavihar registration required for event

    useEffect(() => {

        console.log("Token exists or not :", accessToken);
    
        if (accessToken) {
            memberProfileFetch(); // Load membership data
            eventTxnsHistoryFetch();

        } else {
            signOut();
            navigate('/');
        }
      }, [accessToken])         // Empty dependency array ensures this runs once on mount;

            //Chinmaya Parivar Member
    const [payloadData, setPayloadData] = useState({});
    
    //to populate registered children

    
    //console.log("Fullnames at the beginning:", fullNames, studentFields);
    const [email, setEmail] = useState("");
    useEffect(() => {        
        setEmail(memberProfile.primary.email); // Assign email from memberProfile
    }, [])         // Empty dependency array ensures this runs once on mount
    useEffect(() => {
            eventData.parent.firstName = memberProfile.primary.firstName;
            eventData.parent.lastName = memberProfile.primary.lastName;
            eventData.parent.email = memberProfile.primary.email;
            eventData.parent.mobileNumber = memberProfile.primary.mobileNumber.replace(/[-\s]/g, ''); // Remove hyphens and spaces    
        }, [])         // Empty dependency array ensures this runs once on mount 

    useEffect(() => {
        if (eventTypes && eventTypes.length > 0) {
        // Filter event types where category is 'Donation'
        const donationEventTypes = eventTypes.filter(eventType => eventType.category === 'Pooja');
        const parentEventType = eventTypes.filter(eventType => eventType.eventTypeId === donationEventTypes[0].parentEventTypeId)[0];
        
        setDonationEventType(parentEventType);
        setDonationEventTypes(donationEventTypes); // <-- Add this state to hold filtered events

        // Optionally, set a default event type if needed
        if (donationEventTypes.length > 0) {
            eventData.balaviharYear = parentEventType.eventYear;
            eventData.eventType = parentEventType.name;
            //setTicketPrice(donationEventTypes[0].price);
            //setEventTypeId(donationEventTypes[0].eventTypeId);
            //setMemBvRegdReqd(donationEventTypes[0].memBvRegdReqd);
        }
    }
    }, [eventTypes]);




      // 
    function handleParentChange(e) {
        let newForm = { ...parentFields };
        newForm[e.target.name] = e.target.value;
        setParentFields(newForm);
        eventData.parent = newForm;
    }
    const handleSelectDonation = (e) => {
        setDonation(e.target.value);
        if (e.target.value === 'Other') {
            setOtherDonationFlag(true);
        } else {
            setOtherDonationFlag(false);
        }
        setSelectedAmount(e.target.value);
        console.log("Amount :", e.target.value);
    }
    const handleSelectSponsorship = (e) => {
        const selectedPrice = parseInt(e.target.value, 10);
        setSponsorship(selectedPrice);

        // Find the selected event type object from donationEventTypes
        const selectedEventType = donationEventTypes.find(
            (eventType) => eventType.price === selectedPrice
        );

        if (selectedEventType) {
            setEventTypeId(selectedEventType.eventTypeId);

            // Set ticketPrice and noOfPeople for correct calculations
            setTicketPrice(selectedPrice);
            setNoOfPeople(1);

            // Update eventData.events with the selected event
            setEventData(prev => ({
                ...prev,
                events: [{
                    memberId: memberProfile.primary.memberId,
                    eventTypeId: selectedEventType.eventTypeId,
                }],
                transaction: {
                ...prev.transaction,
                quantities: 1, // <-- Set quantities to 1 when an event is selected
                itemPrice: selectedPrice
            }
            }));
        }
        console.log("Sponsorship Amount :", e.target.value, eventData.events);
    }
 
    const total = () => {
        inputFields.donationAmount = donation;
        inputFields.totalAmount = totalAmount;
        eventData.transaction = inputFields;
    }
    total();
    
    useEffect(() => {


        eventData.transaction.itemPrice = ticketPrice;
        eventData.transaction.quantities = noOfPeople;
        eventData.transaction.donationAmount = parseInt(donation || 0);
        // Add sponsorship to donation in total calculation

        if (feeEnabled) {
            setTotalAmount(((parseInt(noOfPeople) * parseInt(ticketPrice) + parseInt(donation)) * 1.03).toFixed(2));
        } else {
            setTotalAmount((parseInt(noOfPeople) * parseInt(ticketPrice) + parseInt(donation)) * 1.00);
        }

        eventData.transaction.totalAmount = totalAmount;
        console.log("Run 1 calculate price :", (eventData.events), ticketPrice, totalAmount);

    }, [noOfPeople, donation, sponsorship, feeEnabled, ticketPrice, eventData.events, memberships.totalAmountPaid, memberships.status, parivarMember]);


        
    const eventTxnsHistoryFetch = async () => {
        let response, data;
        try {
            const response = await fetch(`${API_URL}/gquery`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-cmdfw-jwt-token': `${accessToken}`,
                },
                body: JSON.stringify({
                    query: `
                            query {
                              eventsHistory {
                                  events {
                                      memEventsId
                                      status
                                      startDate
                                      endDate
                                      memberEntity {
                                          memberId
                                          memberType
                                          fullName
                                      }
                                      eventTypesEntity {
                                          eventTypeId
                                          name
                                          eventYear
                                      }
                                      transactionEntity {
                                          transactionId
                                          totalAmount
                                          paymentStatus
                                          createdAt
                                      }
                                  }
                                }
                            }
                          `,
                }),
            });

            const data = await response.json();
            if (response.ok) {
                console.log("Event history data API call:", response, data.data.eventsHistory.events);

                setEventTxnsHistory(data.data.eventsHistory.events);
            } else {
                if (response.status === 403) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'OTP expired');
                    //handleLogout(); // Logout user
                } else {
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || 'Membership fetch failed');
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching Event Txns History :", error);
            //signOut();
            //navigate('/');
        }
    };



    const handleLogout = () => {
        signOut();
        navigate('/');
      };

    const memberProfileFetch = async () => {
        console.log("Membership profile fetch", accessToken);
        let response, data;
        try {    
          //const response = await fetch('https://membership.cmdfw.org/api/gquery', {
          const response = await fetch(`${API_URL}/gquery`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-cmdfw-jwt-token': `${accessToken}`,
            },
              body: JSON.stringify({
                  query: `
                          query {
                            memberships {
                                balaviharYear
                                balaviharPeriod
                                status
                                totalAmountPaid
                                membershipTypes {
                                    membershipTypeId
                                    name
                                    startDate
                                    endDate
                                    bvPrice
                                    childQuantities
                                }
                                availableSessions {
                                    sessionId
                                    center
                                    sessionName
                                    grades {
                                        gradeId
                                        grade
                                    }
                                }
                                registeredSessions{
                                    bvRegistrationId
                                    regStartDate
                                    regEndDate
                                    status
                                    memberEntity{
                                        firstName
                                        lastName
                                        fullName
                                    }
                                    sessionEntity {
                                        sessionId
                                        center
                                        sessionName
                                    }
                                    gradeEntity{
                                        gradeId
                                        grade
                                    }
                                }
                                currentMembership {
                                    membershipId
                                    startDate
                                    endDate
                                    status
                                    notes
                                    bvYear
                                    createdAt 
                                    createdBy 
                                    membershipTypesEntity{
                                        membershipTypeId
                                        name
                                        startDate
                                        endDate
                                    }
                                    transactionEntity {
                                        transactionId
                                        eventTypesEntity {
                                            eventTypeId
                                            name
                                            eventYear
                                        }
                                        totalAmount
                                        paymentStatus
                                        createdAt 
                                        createdBy 
                                    }
                                }
                            }
                          }
                        `,
            }),
          });
    
          const data = await response.json();
          if (response.ok) {
            setMemberships(data.data.memberships);
            console.log("Membership data after API call:", data, response);
          } else {
            if (response.status === 403) {
              const errorData = await response.json();
              handleLogout(); // Logout user
              throw new Error(errorData.message || 'OTP expired');
            } else {
              if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Membership fetch failed');
              }
            }
          }
        } catch (error) {
          console.error("Error fetching Membership Profile :", error);
          signOut();
          //navigate('/');
        }
      };
     

    const checkoutHandler = (e) => {
        e.preventDefault();
        setError(null);
        // Skip payment if total amount is zero
        if (totalAmount >0 ) {        
            eventData.status = "pending";
        } else {
            eventData.status = "paid";
            setSuccess(true); // Skip payment if total amount is zero
        }
        setPayloadData(eventData); 

        //    console.log("transaction before sent to SQS:", (inputFields));
        if (sendToServer()) {
            console.log("checkout true");
            //setCheckout(true);
        } else {
            //setCheckout(false);
            console.log("checkout false");
        }
    };
    async function sendToServer() {
        const maxRetries = 3; // Maximum number of retries
        let attempt = 0;
        let url_link = `${API_URL}/events`;
        console.log("transaction before sent to Database:", eventData, url_link);


        while (attempt < maxRetries) {
            try {
            //const response = await fetch(`${API_URL}/events`, {
            const response = await fetch(url_link, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "x-cmdfw-jwt-token": `${accessToken}`,
                },
                body: JSON.stringify(eventData),
            });
            console.log('API response:', response.data);
            if (response.ok) {
                setCheckout(true);
                return true; // Success
            }
            if (response.status === 403) {
                const errorData = await response.json();
                handleLogout(); // Logout user
                throw new Error(errorData.message || 'OTP expired');
              } else {
                const errorData = await response.json();
                console.error('API Error:', errorData);
                setError(errorData.message);
                return false; // API call failed
                //throw new Error(errorData.message || 'API call failed');
            }
        } catch (error) {
            console.error(`Attempt ${attempt + 1} failed:`, error);
            attempt++;

            if (attempt >= maxRetries) {
                console.error('All retry attempts failed.');
                setCheckout(false);
                setError("Failed to send data to the server. Please try again later.");
                return false; // Return false after all retries fail
            }

            console.log(`Retrying API call... (${attempt}/${maxRetries})`);
 
        }
    }
    }


    function feeSwitchHandler(e) {
        setError(null); // Clear any existing errors
        setFeeEnabled(e.target.checked);
        eventData.feeEnabled = e.target.checked ;
    }
    function checkOutEnableHandler(e) {
        setError(null); // Clear any existing errors
        setRulesAccepted(e.target.checked)
    }
    function handleBack() {
        setCheckout(false);
    }

    function handleDonation(e) {
        setInputFields({ ...inputFields, [e.target.name]: parseInt(e.target.value) });
        if (e.target.value >= 0) {
            setDonation(parseInt(e.target.value));
        }
    };

    const handleCancel = () => {
        navigate('/EventTypesForm');
        // Add any additional save logic here, such as API calls
      };
    
 
    const [success, setSuccess] = useState(false)
    const [checkout, setCheckout] = useState(false)


    return (
        <div>
            <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" gutterBottom>
                        {'CMDFW Registration System'}
                    </Typography>
                </Grid>

            <form onSubmit={checkoutHandler}>
                <Grid container direction="column" alignItems="center" >
                    {
                        checkout ?
                            success  ?
                                <Grid item>
                                    <img src={successIcon} className="Success-icon" alt="logo" />
                                    <Typography variant="h5" align="center" gutterBottom>
                                        {'Thank You for the Registration'}
                                    </Typography>
                                    <Box sx={{ width: '100%', maxWidth: 500 }}>
                                        <Typography variant="body2" align="left" gutterBottom>
                                            You will receive an email confirmation to this address <b> [ {email} ] </b>
                                        </Typography>
                                    </Box>
                                </Grid>
                                :
                                
                                <Grid item>
                                    <PaypalZelle eventData={eventData} setSuccess={setSuccess} payloadData={payloadData}/>
                                    <span>
                                        <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} onClick={() => handleBack()}>Back</Button>
                                    </span>
                                </Grid>
                            :
                            <div>
                                <Grid item xs={12} sm={12}>
                                <Paper elevation={3}>
                                <Paper style={{ padding: '16px', backgroundColor: '#dfe7e7', color: 'black' }} elevation={3}>
                                    <Grid item>
                                        <Box sx={{ width: '100%', minWidth: 300 }}>
                                            <Typography variant="body2" align="left" gutterBottom>
                                                <div>{parse(donationEventType.desc || "")}</div><br />
                                                <div><br /></div>
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    </Paper>
                                    </Paper>
                                </Grid>
                                <div><br /></div>
                                <Grid item xs={12} sm={12}>
                                {
                                    memberships.status === "ACTIVE" ?
                                        (
                                        <div>
                                        <div>Membership status is <b>Active</b> for the period: <b>{memberships.balaviharPeriod}</b></div>
                                        <div>Membership Type : <b>{memberships.currentMembership.membershipTypesEntity.name}</b></div>
                                        <div><br /></div>
                                        </div>
                                        )

                                        :
                                    memBvRegdReqd && memberships.status !== "ACTIVE" &&       
                                        (
                                        <div><b>Membership expired.</b> 
                                        <div><b>RENEW</b> the membership for the period: <b>{memberships.balaviharPeriod}</b></div>
                                                    <div><br /></div>
                                                    <Grid item xs={12} sm={12}>
                                                        <Paper elevation={3}>
                                                            <Paper style={{ padding: '16px', backgroundColor: '#dfe7e7', color: 'black' }} elevation={3}>
                                                                <Grid item>
                                                                    <Box sx={{ width: '100%', minWidth: 300 }}>
                                                                        <Typography variant="body2" align="left" gutterBottom>

                                                                            <div><b>Your Membership has expired. Please RENEW your membership before registering for Labor Day Retreat. </b></div>
                                                                            
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                            </Paper>
                                                        </Paper>
                                                    </Grid>
                                                    <Grid item>
                                                        <Button onClick={handleCancel} variant="contained" sx={{ mt: 3, mb: 2 }}>Cancel</Button>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography variant="body2" align="center" gutterBottom>
                                                            If you have any questions, please contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
                                                        </Typography>
                                                    </Grid>

                                                </div>
                                                
                                        )
                                        }                        
                                    
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    {
                                        (memBvRegdReqd && memberships.status === "ACTIVE") || !memBvRegdReqd ?
                                            <Grid container alignItems="center" >
                                                                                                <Grid container alignitems="left" spacing={2}>
                                                    <Grid item xs={12} sm={12}>
                                                        <Paper elevation={3}>
                                                            <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                                                <Typography variant="h7" align="left" gutterBottom>
                                                                    <b>Puja Sponsorship</b>
                                                                </Typography>
                                                            </Paper>
                                                            <div><br /></div>

                                                            <Grid item xs={12} sm={12}>
                                                                <FormControl>
                                                                    <FormLabel id="donation-radio-buttons-group-label">Select Sponsorship</FormLabel>
                                                                    <RadioGroup
                                                                        aria-labelledby="donation-radio-buttons-group-label"
                                                                        value={sponsorship}
                                                                        onChange={handleSelectSponsorship}
                                                                        name="donation-radio-buttons-group"
                                                                    >
                                                                        {donationEventTypes && donationEventTypes.map((eventType) => (
                                                                            <FormControlLabel
                                                                                key={eventType.eventTypeId}
                                                                                value={eventType.price}
                                                                                control={<Radio />}
                                                                                label={`$${eventType.price} (${eventType.name})`}
                                                                            />
                                                                        ))}
                                                                    </RadioGroup>
                                                                </FormControl>
                                                            </Grid>
                                                            <div><br /></div>



                                                        </Paper>
                                                    </Grid>
                                                </Grid>
                                                            <div><br /></div>

                                                <Grid item>
                                                    <Grid container alignItems="left" >
                                                        <div><br /></div>
                                                     
                                                        <Paper elevation={3}>
                                                            <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                                                <Typography variant="h7" align="left" gutterBottom>
                                                                    <b>Donor Information</b>
                                                                </Typography>
                                                            </Paper>
                                                            <div><br /></div>
                                                            <Grid item xs={12} sm={12}>
                                                                <Grid container align="left" spacing={2}>
                                                                    <Grid item xs={12} sm={6}>
                                                                        <Paper elevation={3}>
                                                                            <TextField
                                                                                required
                                                                                id="fName"
                                                                                label="First Name"
                                                                                name="firstName"
                                                                                variant="outlined"
                                                                                fullWidth
                                                                                value={parentFields.firstName}
                                                                                onChange={handleParentChange}
                                                                            />
                                                                        </Paper>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={6}>
                                                                        <Paper elevation={3}>
                                                                            <TextField
                                                                                required
                                                                                id="lName"
                                                                                label="Last Name"
                                                                                name="lastName"
                                                                                variant="outlined"
                                                                                fullWidth
                                                                                value={parentFields.lastName}
                                                                                onChange={handleParentChange}
                                                                            />
                                                                        </Paper>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={6}>
                                                                        <Paper elevation={3}>
                                                                            <TextField
                                                                                required
                                                                                id="mobile"
                                                                                label="Mobile Phone"
                                                                                name="mobileNumber"
                                                                                variant="outlined"
                                                                                fullWidth
                                                                                value={parentFields.mobileNumber}
                                                                                onChange={handleParentChange}
                                                                            />
                                                                        </Paper>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={6}>
                                                                        <Paper elevation={3}>
                                                                            <TextField
                                                                                type="email"
                                                                                fullWidth
                                                                                required
                                                                                id="email"
                                                                                label="Email"
                                                                                variant="outlined"
                                                                                name="email"
                                                                                value={parentFields.email}
                                                                                onChange={handleParentChange}
                                                                            />
                                                                        </Paper>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Paper>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            : ""}

                                </Grid>
                                                                                       
                                {
                                (memBvRegdReqd && memberships.status === "ACTIVE") || !memBvRegdReqd ? (  
                                <Grid item xs={12} sm={12}>                  
                                <div><br /></div>
                                <Paper elevation={3}>
                                        <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                        <Typography variant="h7" align="left" gutterBottom>
                                            <b>Payment Information</b>
                                        </Typography>
                                </Paper>
                                <div><br /></div>
                                
                                <div><br /></div>
                                <Grid container direction="row" spacing={2} >
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            number
                                            id="donation"
                                            label="Additional Donation ($)"
                                            type="number"
                                            name="donation"
                                            variant="standard"
                                            value={donation}
                                            onChange={handleDonation}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox checked={feeEnabled} />} label="Add 3% to cover for CC fees"
                                                value={feeEnabled} size="small" onChange={feeSwitchHandler} />
                                        </FormGroup>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            fullWidth
                                            disabled
                                            id="totalAmountField"
                                            label="Total Amount($)"
                                            type="number"
                                            name="totalAmount"
                                            variant="standard"
                                            inputProps={{ style: { fontSize: 20 } }} // font size of input text
                                            InputLabelProps={{ style: { fontSize: 20 } }} // font size of input label
                                            value={totalAmount}
                                        />
                                    </Grid>
                                </Grid>
                                </Paper>

                                <div><br /></div>
                                <Grid container direction="row" spacing={5}>
                                    <Grid item>
                                        <Typography variant="body2" align="center" gutterBottom>
                                        <b>Waiver Statement (Please read and agree to the waiver statement before you proceed) :</b> <a href="https://membership.cmdfw.org/docs/cmdfw-waiver.pdf" target="_blank" rel="noopener noreferrer"> Open PDF </a>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container direction="row" spacing={5}>
                                    <Grid item>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={rulesAccepted}
                                                    onChange={checkOutEnableHandler}
                                                    name="rulesAccepted"
                                                    color="primary"
                                                />
                                            }
                                            label="I accept the rules and policies"
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container direction="row" spacing={2}>
                                    
                                    <Grid item>
                                        <Button onClick={handleCancel} variant="contained" sx={{ mt: 3, mb: 2 }}>Cancel</Button>
                                    </Grid>
                                    <Grid item>
                                    <Tooltip title={!rulesAccepted ? "Please accept the rules and policies" : ""}>
                                        <span>
                                        <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} disabled={!rulesAccepted}>Checkout</Button>
                                        </span>
                                    </Tooltip>
                                    </Grid>
                                    {error && (
                                        <Grid item xs={12}>
                                            <Alert severity="error">{error}</Alert>
                                        </Grid>
                                    )}
                                </Grid>
                                    <Grid container direction="row" spacing={5}>
                                    <Grid item>
                                        <Typography variant="body2" align="center" gutterBottom>
                                            If you have any questions, please contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                </Grid> ) : "" }
                            </div> 
                    }
                </Grid>
            </form>
        </div >
    );
}